/* TAJI — Produits vus récemment (code original, localStorage) */
(function () {
  const STORAGE_KEY = 'taji:recently-viewed';
  const MAX_ITEMS = 12;

  function readStore() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function writeStore(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, MAX_ITEMS)));
    } catch (e) {
      /* stockage indisponible : fonctionnalité simplement inactive */
    }
  }

  if (!customElements.get('taji-recently-viewed')) {
    customElements.define(
      'taji-recently-viewed',
      class TajiRecentlyViewed extends HTMLElement {
        connectedCallback() {
          /* 1. Enregistre le produit courant si la section est sur une fiche produit */
          const current = this.dataset.currentHandle
            ? {
                handle: this.dataset.currentHandle,
                title: this.dataset.currentTitle,
                url: this.dataset.currentUrl,
                image: this.dataset.currentImage,
                price: this.dataset.currentPrice,
              }
            : null;

          let items = readStore();
          if (current && current.handle) {
            items = [current, ...items.filter((i) => i.handle !== current.handle)];
            writeStore(items);
          }

          /* 2. Affiche les autres produits vus */
          const display = items.filter((i) => !current || i.handle !== current.handle);
          const limit = parseInt(this.dataset.limit, 10) || 4;
          const grid = this.querySelector('.taji-recent__grid');
          if (!grid || !display.length) {
            this.closest('.taji-recent-section')?.classList.add('taji-recent--empty');
            return;
          }
          display.slice(0, limit).forEach((item) => {
            const card = document.createElement('a');
            card.className = 'taji-recent__card';
            card.href = item.url;
            const img = document.createElement('img');
            img.loading = 'lazy';
            img.src = item.image || '';
            img.alt = item.title || '';
            img.width = 300;
            img.height = 300;
            const title = document.createElement('p');
            title.className = 'taji-recent__title';
            title.textContent = item.title || '';
            const price = document.createElement('p');
            price.className = 'taji-recent__price';
            price.textContent = item.price || '';
            if (item.image) card.appendChild(img);
            card.appendChild(title);
            card.appendChild(price);
            grid.appendChild(card);
          });
        }
      }
    );
  }
})();
